import { ReactNode } from 'react';
import { Card, Group, Stack, Text } from '@mantine/core';
import { formatSkillName } from 'src/common/utils/skillNames';
import { formatRelativeDate } from 'src/utils/dateFormatting';
import type { SkillLibraryEntryListItem } from './types';

type LibraryRowProps = {
  entry: SkillLibraryEntryListItem;
  action: ReactNode;
};

export default function LibraryRow({ entry, action }: LibraryRowProps) {
  const label = formatSkillName(entry.name);

  return (
    <Card withBorder padding="md" radius="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="lg">
        <Stack gap={6} style={{ minWidth: 0 }}>
          <Text fw={600}>{label}</Text>
          <Text size="sm" c="dimmed">
            {entry.description}
          </Text>
          <Text size="xs" c="gray.7">
            {`Shared by ${entry.sharedByCompanyName} · ${formatRelativeDate(entry.sharedAt)}`}
          </Text>
        </Stack>
        <div style={{ flex: 'none' }}>{action}</div>
      </Group>
    </Card>
  );
}
